import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { TransactionMasterService } from '../fraud-prevention/transaction-master-rule/transaction-master-service';
import { environment } from 'src/environments/environment';
import { ColDef, GridApi, PaginationChangedEvent } from 'ag-grid-community';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { AlertService } from 'src/app/_services/alert.service';
import { ExportTrackingService } from 'src/app/_services/export-tracking.service';
import { MenusService } from 'src/app/_services/menu.service';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx'
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { NgSelectComponent } from '@ng-select/ng-select';
import { catchError, forkJoin, map, of } from 'rxjs';

const { API_URL, defaultPageSizeArr, defaultPageSize } = environment;
@Component({
  selector: 'app-merchant-withdrawl-report',
  templateUrl: './merchant-withdrawl-report.component.html',
  styleUrls: ['./merchant-withdrawl-report.component.scss']
})
export class MerchantWithdrawlReportComponent implements OnInit {
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  rowData: any;
  collectiondata: any;
  collectionSize: any;
  totalRecords: any;
  currentPage: number = 1;
  private gridApi!: GridApi;
  private innerWidth: number;
  pageNumber: number;
  public permissions: any = '';
  @ViewChild('modalTopupAction') private topupActionComponent: ModalComponent;
  @ViewChild('filSearchMerName') private filSearchMerName!: NgSelectComponent;
  @ViewChild('filSearchMID') private filSearchMID!: NgSelectComponent;
  @ViewChild('filStatus') private filStatus!: NgSelectComponent;
  @Output() TopupActionSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  public quickFilterShow: boolean = false;
  modalConfigBlocked: ModalConfig;
  transactionStatus:string="";
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 180,
    resizable: true,
    sortable: true,
    // suppressSizeToFit: true,
    // suppressAutoSize: true,
    filter: false,
    autoHeight: true
  };
  public columnDefs: ColDef[] = [
    { field: 'bankDetailsSnapshot.accountTitle', sortable: false, lockVisible: true, headerName: 'Merchant Name' },
    { field: 'bankDetailsSnapshot.iban', sortable: false, lockVisible: true, headerName: 'RIB' },
    { field: 'bankDetailsSnapshot.bankName', sortable: false, lockVisible: true, headerName: 'Bank Name' },
    { field: 'userMobile', sortable: false, lockVisible: true, headerName: 'Registered Mobile' },
    { field: 'txnId', sortable: false, lockVisible: true, headerName: 'Transaction ID' },
    { field: 'transactionType', sortable: false, lockVisible: true, headerName: 'Credit / Debit' },
    { field: 'currency', sortable: false, lockVisible: true, headerName: 'Currency' },
    { field: 'amount', sortable: false, lockVisible: true, headerName: 'Sale Amount' },
    { field: 'serviceCharges', sortable: false, lockVisible: true, headerName: 'Fee Amount' },
    { field: 'status', sortable: false, lockVisible: true, headerName: 'Status' },
    { field: 'dateTime', sortable: false, lockVisible: true, headerName: 'Trxn Initiated Date Time' },
    { field: 'productCode', sortable: false, lockVisible: true, headerName: 'Product Code' },
    { field: 'referenceId', sortable: false, lockVisible: true, headerName: 'Pay10 Reference ID' },
    { field: 'splitPayment', sortable: false, lockVisible: true, headerName: 'Split Payment' },
    {
      field: 'actions', headerName: 'Actions', lockVisible: true, width: 120,
      cellRenderer: BtnCellRenderer1,
      cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            this.tableInfo = param.data.txnId;
            const txnId = param.data.txnId;
            const mobile = param.mobile;
            const status = param.data.status;

            this.TopupActionSelectEvent.emit({ mobile, status, txnId });
            return await this.topupActionComponent.open();
          },
          buttonIconClass: 'icon-settings',
          buttonVisible: true,
        }
      ]
    }
  ];
  maxSize: number;
  ellipses: boolean;
  excelData: never[];
  exportHistory: any;
  tableInfo: any;
  fullName: string;
  mobileNumber: string;
  documentId: string;
  constructor(private router: Router, private menuService: MenusService, private location: Location, private transactionService: TransactionMasterService, private alertService: AlertService, private exportTrackingService: ExportTrackingService) { }

  async ngOnInit(): Promise<void> {
    this.innerWidth = window.innerWidth;
    this.setPageSize();
    const path = this.location.prepareExternalUrl(this.location.path());
    // this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions)
    // if (this.permissions == null || this.permissions == '' || !this.permissions) {
    //   this.alertService.errorAlert({
    //     title: "No Access",
    //     backdrop: true,
    //     toast: true,
    //     timer: 1500
    //   })
    //   await this.router.navigateByUrl('/');
    // }

    this.modalConfigBlocked = {
      modalTitle: "Merchant Status",
      modalSize: 'lg',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }
  }
  setPageSize() {
    if (this.innerWidth <= 1600 && this.innerWidth >= 1200) {
      this.maxSize = 5;
    } else if (this.innerWidth <= 1199 && this.innerWidth >= 768) {
      this.maxSize = 3;
      this.ellipses = false;
    } else if (this.innerWidth < 768) {
      this.maxSize = 2;
      this.ellipses = false;
    }
  }
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];


  onSortChange(event: any) {
    this.transactionService.getMerchantWithdrawlReport(this.transactionStatus, this.pageSize, this.pageNumber, this.mobileNumber)
      .subscribe((data: any) => {
        console.log(data);
        this.rowData = data.response.data.content;
        this.rowData.map((_: any) => {
          _.splitPayment = 'N';
          if (_.longitude != null && _.latitude != null) {
            _.gps = _.longitude + " , " + _.latitude;
          } else {
            _.gps = '';
          }
        })
        this.collectiondata = data.response.data.content
        this.collectionSize = data.response.data.totalElements
        this.totalRecords = data.response.data.totalElements
      });
  }

onGridReady() {

  this.transactionService.getMerchantWithdrawlReport(
    this.transactionStatus,
    this.pageSize,
    this.pageNumber,
    this.mobileNumber
  ).subscribe((data: any) => {

    const rows = data.response.data.content;

    if (!rows || rows.length === 0) {
      this.rowData = [];
      this.collectiondata = [];

      this.collectionSize = data.response.data.totalElements;
      this.totalRecords = data.response.data.totalElements;
      return;
    }

    const bankRequests = rows.map((row: any) => {

      const bankId = row.bankDetailsSnapshot?.bankName;

      // If bank ID is null/undefined, don't call bank API
      if (bankId === null || bankId === undefined || bankId === '') {
        return of(row);
      }

      return this.transactionService
        .getAllMerchantMoroccanBank(bankId)
        .pipe(
          map((response: any) => {

            const banks = response.response.data;

            const bank = banks.find(
              (bank: any) => bank.id == bankId
            );

            // Set bank name on the same field
            row.bankDetailsSnapshot.bankName =
              bank ? bank.name : bankId;

            return row;
          }),
          catchError(() => {
            // Keep original value if API fails
            return of(row);
          })
        );
    });

    forkJoin<any[]>(bankRequests).subscribe((updatedRows: any[]) => {

      this.rowData = updatedRows;
      this.collectiondata = updatedRows;

      this.collectionSize = data.response.data.totalElements;
      this.totalRecords = data.response.data.totalElements;
    });

  });
}

  onPaginationChange(param: PaginationChangedEvent | any) {
    console.log(param);
    this.pageNumber = (param - 1);
    this.onGridReady()
  }

  onPageSizeChanges($event: Event) {
    this.pageNumber = 0;
    this.onGridReady();

  }


  onExport() {
    const transactionIds = this.rowData
      .map((row: any) => row.txnId);

    if (transactionIds.length === 0) {

      this.alertService.errorAlertWithMessage(
        "Please select at least one transaction."
      );

      return;
    }
     const request = {
      transactionIds: transactionIds
    };

    this.validateTransactions(request);

  }

  validateTransactions(transactionIds: any) {

    this.transactionService
      .validateRemittanceExport(transactionIds)
      .subscribe({
        next: (response: any) => {
          if (response.valid) {
            this.exportTransactions(transactionIds);
          } else {
            this.alertService.errorAlertWithMessage(
              response.message
            );
          }
        },
        error: (error) => {
          this.alertService.errorAlertWithMessage(
            error.error.message
          );
        }
      });

  }


  exportTransactions(transactionIds: string[]) {

    this.transactionService
      .exportRemittance(transactionIds).subscribe({
        next: (response: any) => {
          const exportData = response;
          this.downloadFile(exportData.downloadId,exportData.fileName);
          this.alertService.successAlert("Export Successful");
          this.onGridReady();
        },

        error: (error) => {
          this.alertService.errorAlertWithMessage(
            error.error.message
          );

        }

      });

  }

  downloadFile(fileId: string, fileName: string) {
    this.transactionService
      .downloadRemittanceFile(fileId)
      .subscribe((blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
      });
  }

  loadExportHistory() {
    this.transactionService
      .getExportHistory("", 10, 0)
      .subscribe((data: any) => {
        this.exportHistory = data.response.data.content;
      });

  }

  resendNotification(sequenceNumber: string) {

    this.transactionService
      .resendExportNotification(sequenceNumber)
      .subscribe({
        next: () => {
          this.alertService.successAlert(
            "Notification sent successfully."
          );
        },
        error: (error) => {
          this.alertService.errorAlertWithMessage(
            error.error.message
          );
        }
      });

  }

  closeModalTopup($event: any) {
    if (!$event.showModal) {
      this.topupActionComponent.close();
      this.refreshGrid();
    }
  }

  refreshGrid() {
    return this.transactionService.getMerchantWithdrawlReport(this.transactionStatus,  this.pageSize, this.pageNumber, this.mobileNumber)
      .subscribe((data: any) => {
        console.log(data);
        this.rowData = data.response.data.content;
        this.collectiondata = data.response.data.content
        this.collectionSize = data.response.data.totalElements
        this.totalRecords = data.response.data.totalElements
      });

  }

  quickFilterShowAction($event: Event) {
    this.quickFilterShow = !this.quickFilterShow;
    if (!this.quickFilterShow) {
      this.filSearchMerName?.handleClearClick?.();
      this.filSearchMID?.handleClearClick?.();
      this.filStatus?.handleClearClick?.();
      this.refreshGrid();
    }
  }

  resetFilter() {
    this.fullName = "";
    this.mobileNumber = "";
    this.documentId = "";
    this.filStatus?.handleClearClick?.();
    this.refreshGrid();
  }

  onSearchBtnClick($event: Event) {
    this.currentPage = 1;
    this.pageNumber = 0;

    return this.transactionService.getMerchantWithdrawlReport(this.transactionStatus, this.pageSize, this.pageNumber, this.mobileNumber)
          .subscribe((data: any) => {

      this.rowData = data.response.data.content;
        this.rowData.map((_: any) => {
          _.splitPayment = 'N';
          if (_.longitude != null && _.latitude != null) {
            _.gps = _.longitude + " , " + _.latitude;
          } else {
            _.gps = '';
          }
        })
      this.collectiondata = data.content;
      this.collectionSize = data.totalElements;

      if (!this.rowData || this.rowData.length <= 0) {
        this.alertService.errorAlertWithMessage("No records present");
        return;
      }
    });
  }
  funover(id: any) {
    document?.getElementById(id)?.classList.remove("hey");
  }
  fun(id: any) {
    document?.getElementById(id)?.classList.add("hey");
  }

}
